import {
  Component,
  Inject,
  OnInit,
  Optional,
  CUSTOM_ELEMENTS_SCHEMA,
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {
  Observable,
  of as observableOf,
} from 'rxjs';
// import { PageFeedbackComponent } from "src/app/shared/page-feedback/page-feedback.component";

// import {
//   APP_CONFIG,
//   AppConfig,
// } from '../../config/app-config.interface';
// import { NotifyInfoService } from '../core/coar-notify/notify-info/notify-info.service';
// import { AuthorizationDataService } from '../core/data/feature-authorization/authorization-data.service';
// import { FeatureID } from '../core/data/feature-authorization/feature-id';
// import { KlaroService } from '../shared/cookies/klaro.service';
// import { hasValue } from '../shared/empty.util';
import { Router } from '@angular/router';
@Component({
  selector: 'app-footer',
  styleUrls: ['footer.component.scss'],
  templateUrl: 'footer.component.html',
  standalone: true,
  imports: [RouterLink, TranslateModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FooterComponent implements OnInit {
  dateObj: number = Date.now();

  /**
   * A boolean representing if to show or not the top footer container
   */
  showTopFooter = false;
  // showPrivacyPolicy: boolean;
  // showEndUserAgreement: boolean;
  // showSendFeedback$: Observable<boolean>;
  // coarLdnEnabled$: Observable<boolean>;
  isHome = false;
  isService = false;
  isRightAligned = false;
  constructor(
    // @Optional() public cookies: KlaroService,
    // protected authorizationService: AuthorizationDataService,
    // protected notifyInfoService: NotifyInfoService,
    // @Inject(APP_CONFIG) protected appConfig: AppConfig,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.checkRoute();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.checkRoute();
      }
    })
  }

  checkRoute() {
    this.isHome = this.router.url === '/' || this.router.url === '/home';
    this.isService = this.router.url.includes('service-details');
    this.isRightAligned = this.router.url === '/home/contact-us' || this.router.url === '/home/services' || this.isHome;
  }

  ngOnInit(): void {
    // this.showPrivacyPolicy = this.appConfig.info.enablePrivacyStatement;
    // this.showEndUserAgreement = this.appConfig.info.enableEndUserAgreement;
    // this.coarLdnEnabled$ = this.appConfig.info.enableCOARNotifySupport ? this.notifyInfoService.isCoarConfigEnabled() : observableOf(false);
    // this.showSendFeedback$ = this.authorizationService.isAuthorized(FeatureID.CanSendFeedback);
  }

  showCookieSettings() {
    // if (hasValue(this.cookies)) {
    //   this.cookies.showSettings();
    // }
    return false;
  }
      openExternalLink() {
  window.open(
    'https://portal.maeen-library.com/about-complex/help/contact-us',
    '_blank'
  );
}
}
